<template>
	<div class="bankrecharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.push('/user')"></div>
			<div class="big_tit">{{ data.payment.bank }}</div>
		</div>
		<div class="bank_detail">
			<div class="item">
				<p class="info">
				{{$t('invest_qrcode.amount')}}
				<span>{{$t('utils.moneyMark')}}{{money}}</span>
				<span>{{actualAmount}}</span>
				</p>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.name')}}
				<span>{{ data.payment.username }}</span></p>
				<div class="copy_btn" v-clipboard="() => data.payment.username " v-clipboard:success="copy">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.account')}}
				<span>{{ data.payment.account }}</span></p>
				<div class="copy_btn" v-clipboard="() => data.payment.account " v-clipboard:success="copy">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.bank')}}
				<span>{{ data.payment.bank }}</span></p>
				<div class="copy_btn" v-clipboard="() => data.payment.bank " v-clipboard:success="copy">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<!-- <div class="item">
				<p class="info">付款人：<input type="text" v-model.trim="pay_user" placeholder="请输入付款人"></p>
			</div>
			<div class="item">
				<p class="info">附言：<input type="text" v-model.trim="pay_remark" placeholder="请输入充值附言"></p>
			</div> -->
		</div>
		<div class="voucher_box">
			<div class="voucher_title">{{$t('invest_qrcode.voucherTitle')}}</div>
			<div class="voucher_upload_area">
				<van-uploader
					v-model="fileList"
					:max-count="1"
					:max-size="5 * 1024 * 1024"
					:before-read="beforeRead"
					:after-read="afterRead"
					@oversize="onOversize"
					@delete="onDelete"
				>
					<div class="voucher_placeholder" v-if="!fileList.length">
						<span class="voucher_plus">+</span>
					</div>
				</van-uploader>
			</div>
			<div class="voucher_hint">{{$t('invest_qrcode.voucherHint')}}</div>
		</div>
		<div class="basic_btn" @click="submitBtn">{{$t('utils.submit')}}</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Button,
		Uploader
	} from "vant";
	import Fetch from "../../utils/fetch";
	import Api from "../../interface/index";
	import Clipboard from "v-clipboard";
	import { isAllowedVoucherFile, normalizeVoucherFile, uploadVoucherFile } from "../../utils/voucherUpload";

	Vue.use(Button).use(Uploader).use(Clipboard);

	export default {
		name: "invest_bank",
		data() {
			return {
				data: {},
				pay_user: '',
				pay_remark: '',
				money: 0,
				actualAmount:'',
				voucher: '',
				fileList: [],
				uploading: false,
				submitting: false,
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
		mounted() {
			this.money = this.$route.query.money ? this.$route.query.money : "";
			if (!this.money || !this.$route.query.id) {
				this.$router.replace('/invest');
				return;
			}
			this.start();
		},
		methods: {
			copy() {
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			start() {
				Fetch("/user/recharge_type", {
					money: this.$route.query.money ? this.$route.query.money : "",
					id:this.$route.query.id ? this.$route.query.id : ""
				}).then((r) => {
					this.data = r.data;
					this.changeAmount();
				});
			},
			submitBtn() {
				if (this.uploading) {
					this.$toast({
						className: "toastName",
						message: this.$t('invest_qrcode.voucherUploading'),
					});
					return;
				}
				if (!this.voucher) {
					this.$toast({
						className: "toastName",
						message: this.$t('invest_qrcode.voucherEmpty'),
					});
					return;
				}
				if (this.submitting) return;
				this.submitting = true;
				Fetch("/user/recharge_apply", {
					id: this.data.orderId,
					voucher: this.voucher,
				}).then((r) => {
					this.submitting = false;
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				}).catch(() => {
					this.submitting = false;
				});
			},
			onOversize() {
				this.$toast(this.$t('invest_qrcode.voucherOversize'));
			},
			beforeRead(file) {
				const f = (file && file.file) ? file.file : (Array.isArray(file) ? file[0] : file);
				if (!isAllowedVoucherFile(f)) {
					this.$toast(this.$t('invest_qrcode.voucherType'));
					return false;
				}
				return true;
			},
			async afterRead(item) {
				const raw = item.file || (item instanceof File ? item : null);
				if (!raw) return;
				this.uploading = true;
				this.voucher = '';
				try {
					const file = await normalizeVoucherFile(raw);
					const url = await uploadVoucherFile(file, {
						commonUrl: Api.commonUrl,
						token: localStorage.getItem('token'),
						language: this.$i18n.locale || localStorage.getItem('lang') || 'zh_cn',
					});
					if (!url) {
						throw new Error('empty url');
					}
					this.voucher = url;
				} catch (err) {
					this.$toast((err && err.message) || this.$t('invest_qrcode.voucherUploadFail'));
					this.fileList = [];
					this.voucher = '';
				} finally {
					this.uploading = false;
				}
			},
			onDelete() {
				this.voucher = '';
			},
			changeAmount() {
				var num = 2;
				if (this.data.payment.type == 1) {
					if (this.data.payment.rate > 10000) {
						num = 8;
					} else if (this.data.payment.rate > 1000) {
						num = 6;
					} else if (this.data.payment.rate > 10) {
						num = 4;
					}
					this.actualAmount = "(≈" + (this.money / this.data.payment.rate).toFixed(num) + this.data.payment.mark+")";
				} else {
					this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num)+")";
				}
			}
		},
	};
</script>

<style lang="less" scoped>
	.bankrecharge_wrap {
		background: #fd1c5f !important;
		width: 100%;
		min-height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		padding-bottom: 30px;
	}
	.red_top_bg{
		background: #fd1c5f;
	}
	.bank_detail {
		width: 96%;
		margin-left: 2%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-top: 12px;
		padding: 30px 16px;
		font-size: 14px;

		.item {
			height: 52px;
			border-bottom: 1px solid #ececec;
			line-height: 52px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.info {
				font-weight: bold;
				color: #000;
				span:nth-child(1){
					font-weight: initial;
				}
				span:nth-child(2){
					color: #999;
					font-size: 14px;
				}
			}

			.copy_btn {
				color: #3d96ff;
				font-size: 12px;
			}
		}
	}

	.warming {
		margin-top: 17px;
		padding: 0 14px;

		.tit {
			font-size: 14px;
			color: rgba(0, 0, 0, .8);
			line-height: 20px;
			font-weight: bold;
		}

		.content {
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			line-height: 17px;
			margin-top: 9px;
		}
	}

	.basic_btn {
		margin: 30px auto 0 auto;
		background: linear-gradient(90deg, #672ee4 0%, #16b4ff 100%);
	}

	.voucher_box {
		width: 96%;
		margin: 12px auto 0;
		padding: 20px 16px 16px;
		background: #fff;
		border-radius: 6px;
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);

		.voucher_title {
			font-size: 16px;
			color: #333;
			font-weight: bold;
			text-align: center;
			margin-bottom: 16px;
		}

		.voucher_hint {
			font-size: 12px;
			color: #999;
			text-align: center;
			margin-top: 12px;
			line-height: 18px;
		}

		.voucher_upload_area {
			width: 100%;

			.voucher_placeholder {
				width: 100%;
				height: 160px;
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				background: #fafafa;
				display: flex;
				align-items: center;
				justify-content: center;

				.voucher_plus {
					font-size: 40px;
					color: #ccc;
					line-height: 1;
					font-weight: 300;
				}
			}

			/deep/ .van-uploader {
				width: 100%;
			}

			/deep/ .van-uploader__wrapper {
				justify-content: center;
				width: 100%;
			}

			/deep/ .van-uploader__input-wrapper {
				width: 100%;
			}

			/deep/ .van-uploader__upload {
				width: 100%;
				height: 160px;
				margin: 0;
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				background: #fafafa;
			}

			/deep/ .van-uploader__upload-icon {
				font-size: 40px;
				color: #ccc;
			}

			/deep/ .van-uploader__preview {
				width: 100%;
				margin: 0;
			}

			/deep/ .van-uploader__preview-image {
				width: 100%;
				height: 160px;
				object-fit: contain;
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				background: #fafafa;
			}

			/deep/ .van-uploader__preview-delete {
				width: 22px;
				height: 22px;
				border-radius: 50%;
				background: rgba(0, 0, 0, 0.45);
				top: 8px;
				right: 8px;
			}
		}
	}
</style>
